(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cutfound-artisanship-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-art-story')) {
  customElements.define('cf-art-story', class extends HTMLElement {
    connectedCallback() {
      this.frameRequest = 0;
      this.animationRequest = 0;
      this.activeStep = -1;
      this.craftStage = -1;
      this.elapsed = 0;
      this.lastTick = null;
      this.manualPause = false;
      this.craftVisible = false;
      this.durations = [18000, 8800, 11500];
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopQuery = window.matchMedia('(min-width: 900px)');
      this.steps = Array.from(this.querySelectorAll('[data-step]'));
      this.frames = Array.from(this.querySelectorAll('[data-frame]'));
      this.craftSteps = Array.from(this.querySelectorAll('[data-craft-step]'));
      this.craftScroll = this.querySelector('[data-craft-scroll]');
      this.stage = this.querySelector('.cf-art__craft-stage');
      this.stage.replaceChildren();
      this.inlinePanels = this.craftSteps.map(step => step.querySelector('.cf-art__illustration'));
      this.craftPanels = this.inlinePanels.map(original => {
        const panel = original.cloneNode(true);
        const ids = new Map();
        panel.querySelectorAll('[id]').forEach(element => {
          ids.set(element.id, element.id + '-stage');
          element.id += '-stage';
        });
        panel.querySelectorAll('*').forEach(element => {
          element.getAttributeNames().forEach(name => {
            let value = element.getAttribute(name);
            ids.forEach((next, previous) => { value = value.replaceAll('#' + previous, '#' + next); });
            element.setAttribute(name, value);
          });
        });
        this.stage.append(panel);
        return panel;
      });
      this.studies = this.inlinePanels.map((panel, i) => [panel, this.craftPanels[i]].map(item => ({
        panel: item,
        control: item.querySelector('[data-craft-control]'),
        drawHand: item.querySelector('[data-draw-hand]'),
        drawWire: item.querySelector('[data-drawn-wire]'),
        drawStock: item.querySelector('[data-draw-stock]'),
        drawStockPaths: Array.from(item.querySelectorAll('[data-draw-stock] path')),
        drawHoles: Array.from(item.querySelectorAll('[data-draw-hole]')),
        drawCounter: item.querySelector('[data-draw-counter]'),
        drawMeasure: item.querySelector('[data-draw-measure]'),
        rollHand: item.querySelector('[data-roll-hand]'),
        rollClip: item.querySelector('[data-roll-clip]'),
        straightWire: item.querySelector('[data-straight-wire]'),
        rolledPaths: Array.from(item.querySelectorAll('[data-rolled-thread] path')),
        incoming: item.querySelector('[data-incoming-thread]'),
        incomingPaths: Array.from(item.querySelectorAll('[data-incoming-thread] path')),
        weaveHand: item.querySelector('[data-weave-hand]'),
        seatedRows: Array.from(item.querySelectorAll('[data-seated-row]'))
      })));
      this.reveals = Array.from(this.querySelectorAll('[data-reveal]'));
      this.hero = this.querySelector('.cf-art__hero');
      this.queueUpdate = () => {
        if (this.frameRequest) return;
        this.frameRequest = requestAnimationFrame(() => { this.frameRequest = 0; this.renderScroll(); });
      };
      this.updateMode = () => {
        this.motion = this.dataset.motion === 'true' && !this.motionQuery.matches;
        this.classList.toggle('cf-art--motion', this.motion);
        this.lastTick = null;
        this.studies.forEach((pair, i) => this.paintStudy(i, this.motion && i === this.craftStage ? this.elapsed / this.durations[i] : 1));
        this.updateControls();
        this.queueUpdate();
      };
      this.selectBlock = event => {
        if (!this.contains(event.target)) return;
        const step = event.target.closest('[data-step]');
        if (step) this.setActive(Number(step.dataset.step));
        const craftStep = event.target.closest('[data-craft-step]');
        if (craftStep) this.setCraftStage(Number(craftStep.dataset.craftStep));
      };
      this.controlAnimation = event => {
        const button = event.target.closest('[data-craft-control]');
        if (!button || !this.contains(button) || !this.motion) return;
        if (this.elapsed >= this.durations[this.craftStage]) {
          this.elapsed = 0;
          this.manualPause = false;
        } else {
          this.manualPause = !this.manualPause;
        }
        this.lastTick = null;
        this.updateControls();
        this.scheduleAnimation();
      };
      this.visibilityChange = () => { this.lastTick = null; this.scheduleAnimation(); };
      this.motionQuery.addEventListener('change', this.updateMode);
      this.desktopQuery.addEventListener('change', this.queueUpdate);
      window.addEventListener('scroll', this.queueUpdate, { passive: true });
      window.addEventListener('resize', this.queueUpdate, { passive: true });
      document.addEventListener('shopify:block:select', this.selectBlock);
      document.addEventListener('visibilitychange', this.visibilityChange);
      this.addEventListener('click', this.controlAnimation);
      this.updateMode();
      this.querySelectorAll('img').forEach(img => img.addEventListener('load', this.queueUpdate, { once: true }));
    }
    clamp(number) { return Math.max(0, Math.min(1, number)); }
    ease(number) { const p = this.clamp(number); return p * p * (3 - 2 * p); }
    setActive(index) {
      if (this.activeStep === index) return;
      this.activeStep = index;
      this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      this.frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
    }
    setCraftStage(index) {
      if (this.craftStage === index) return;
      this.craftStage = index;
      this.elapsed = 0;
      this.lastTick = null;
      this.craftPanels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
        panel.inert = i !== index;
        panel.setAttribute('aria-hidden', String(i !== index));
      });
      this.craftSteps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      this.paintStudy(index, this.motion ? 0 : 1);
      this.updateControls();
    }
    nearestStep(steps, height) {
      let selected = 0;
      let distance = Infinity;
      steps.forEach((step, i) => {
        const r = step.getBoundingClientRect();
        const next = Math.abs(r.top + r.height / 2 - height * .54);
        if (next < distance) { distance = next; selected = i; }
      });
      return selected;
    }
    renderScroll() {
      if (!this.isConnected) return;
      const height = window.innerHeight;
      const rect = this.getBoundingClientRect();
      this.style.setProperty('--read-progress', this.clamp(-rect.top / Math.max(1, rect.height - height)).toFixed(3));
      if (this.motion) {
        this.reveals.forEach(el => { if (el.getBoundingClientRect().top < height * .94) el.classList.add('is-visible'); });
        if (this.hero) {
          const heroRect = this.hero.getBoundingClientRect();
          this.style.setProperty('--hero-shift', (this.clamp(-heroRect.top / heroRect.height) * 28).toFixed(1) + 'px');
        }
      }
      if (this.desktopQuery.matches && this.steps.length) this.setActive(this.nearestStep(this.steps, height));
      if (!this.craftSteps.length) return;
      const index = this.nearestStep(this.craftSteps, height);
      this.setCraftStage(index);
      const panel = this.desktopQuery.matches && this.motion ? this.craftPanels[index] : this.inlinePanels[index];
      const r = panel.getBoundingClientRect();
      const scroll = this.craftScroll.getBoundingClientRect();
      this.craftVisible = r.top < height * .82 && r.bottom > height * .2 && scroll.bottom > height * .25 && scroll.top < height * .8;
      if (!this.craftVisible) this.lastTick = null;
      this.scheduleAnimation();
    }
    updateControls() {
      this.studies.forEach((pair, i) => pair.forEach(record => {
        const finished = i === this.craftStage && this.elapsed >= this.durations[i];
        const label = finished ? record.control.dataset.replay : this.manualPause ? record.control.dataset.resume : record.control.dataset.pause;
        record.control.textContent = label;
        record.control.setAttribute('aria-label', label);
      }));
    }
    scheduleAnimation() {
      if (this.animationRequest || !this.motion || this.manualPause || !this.craftVisible || document.hidden || this.craftStage < 0 || this.elapsed >= this.durations[this.craftStage]) return;
      this.animationRequest = requestAnimationFrame(now => {
        this.animationRequest = 0;
        if (!this.motion || this.manualPause || !this.craftVisible || document.hidden || !this.isConnected) { this.lastTick = null; return; }
        if (this.lastTick !== null) this.elapsed += now - this.lastTick;
        this.lastTick = now;
        const progress = this.clamp(this.elapsed / this.durations[this.craftStage]);
        this.paintStudy(this.craftStage, progress);
        if (progress >= 1) { this.lastTick = null; this.updateControls(); } else this.scheduleAnimation();
      });
    }
    coilPath(x, y, length, phase = 0) {
      const points = [];
      for (let t = 0; t <= length; t += 2) {
        const angle = t / 18 * Math.PI * 2 + phase;
        points.push((x + t + 3.7 * Math.sin(angle)).toFixed(2) + ' ' + (y + 9 * Math.cos(angle)).toFixed(2));
      }
      return 'M' + points.join('L');
    }
    paintStudy(index, rawProgress) {
      const p = this.clamp(rawProgress);
      this.studies[index].forEach(record => {
        record.panel.style.setProperty('--study-progress', p.toFixed(3));
        if (index === 0) {
          const holes = [[424,148],[382,161],[340,174],[298,187],[256,200],[424,195],[382,208],[340,221],[298,234],[256,247]];
          const thicknesses = [12,10.2,8.5,7,5.7,4.6,3.7,2.9,2.25,1.65,1.15];
          const pass = Math.min(9, Math.floor(p * 10));
          const local = p >= 1 ? 1 : p * 10 - pass;
          const [holeX, holeY] = holes[pass];
          const pull = this.ease((local - .12) / .65);
          const x = 508 + 42 * pull;
          const opacity = this.ease(local / .08) * (pass === 9 ? 1 : 1 - this.ease((local - .88) / .12));
          record.drawHand.setAttribute('transform', `translate(${x.toFixed(2)} ${holeY})`);
          record.drawHand.style.opacity = String(opacity);
          record.drawStock.setAttribute('transform', `translate(0 ${holeY})`);
          record.drawStock.style.opacity = String(opacity);
          record.drawStockPaths.forEach((path, i) => {
            path.setAttribute('d', `M46 0H${holeX}`);
            path.setAttribute('stroke-width', (thicknesses[pass] * (i ? .62 : 1)).toFixed(2));
          });
          record.drawWire.setAttribute('d', `M${holeX} ${holeY}H${(x - 47).toFixed(2)}`);
          record.drawWire.setAttribute('stroke-width', String(thicknesses[pass + 1]));
          record.drawWire.style.opacity = String(opacity);
          record.drawHoles.forEach((hole, i) => hole.setAttribute('opacity', i === pass ? '1' : '0'));
          record.drawCounter.textContent = `${String(pass + 1).padStart(2, '0')} / 10`;
          record.drawMeasure.style.opacity = pass === 9 ? '1' : '.42';
        } else if (index === 1) {
          const taper = Math.min(this.ease(p / .08), this.ease((1 - p) / .08));
          const stroke = Math.sin(p * Math.PI * 8) * taper;
          const x = 330;
          const y = 236 + stroke * 30;
          record.rollHand.setAttribute('transform', `translate(${x} ${y.toFixed(2)})`);
          record.straightWire.setAttribute('d', `M46 236H${x - 27}`);
          record.rollClip.setAttribute('x', String(x + 36));
          record.rollClip.setAttribute('width', String(724 - x - 36));
          const d = this.coilPath(36, 236, 682, stroke * Math.PI * 1.2);
          record.rolledPaths.forEach(path => path.setAttribute('d', d));
        } else {
          const pass = Math.min(2, Math.floor(p * 3));
          const local = p >= 1 ? 1 : p * 3 - pass;
          const feed = this.ease((local - .08) / .75);
          const x = 240 + (70 + (pass % 2) * 7 - 240) * feed;
          const y = 231 - pass * 14 - 34 * (1 - feed);
          record.seatedRows.forEach((row, i) => { row.style.opacity = i < pass || p >= 1 ? '1' : '0'; });
          record.incoming.style.opacity = p >= 1 ? '0' : '1';
          record.incoming.setAttribute('transform', `translate(${x.toFixed(2)} ${y.toFixed(2)})`);
          const d = this.coilPath(0, 0, 350, (1 - feed) * Math.PI * 6 + (pass % 2) * Math.PI);
          record.incomingPaths.forEach(path => path.setAttribute('d', d));
          const release = this.ease((local - .87) / .13);
          record.weaveHand.setAttribute('transform', `translate(${(x + 354 + release * 13).toFixed(2)} ${(y - release * 13).toFixed(2)})`);
        }
      });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.queueUpdate);
      window.removeEventListener('resize', this.queueUpdate);
      document.removeEventListener('shopify:block:select', this.selectBlock);
      document.removeEventListener('visibilitychange', this.visibilityChange);
      this.removeEventListener('click', this.controlAnimation);
      this.motionQuery?.removeEventListener('change', this.updateMode);
      this.desktopQuery?.removeEventListener('change', this.queueUpdate);
      if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
      if (this.animationRequest) cancelAnimationFrame(this.animationRequest);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutfound-png-product-row"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-product-slider')) {
  customElements.define('cf-product-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cf-png-row__grid');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      if (!this.track || !this.previous || !this.next) return;
      this.update = () => {
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      };
      this.onclick = (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button || !this.contains(button)) return;
        const card = this.track.querySelector('li');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap) : this.track.clientWidth;
        this.track.scrollBy({left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.update);
      this.onclick = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
